import { Theme } from "@pga/pga-component-library"

export const PTM_APPLICATION_TYPES = {
  ASSOCIATE: "associate",
  AFFILIATE: "affiliate",
}

const STATUS_DISPLAY = {
  submitted: { text: "Submitted", color: Theme.colors.lightBlue },
  under_review: { text: "Under Review", color: Theme.colors.orange },
  changes_requested: { text: "Under Review", color: Theme.colors.orange },
  approved: { text: "Approved", color: Theme.colors.successGreen },
  denied: { text: "Declined", color: Theme.colors.maroon },
}

// Statuses that replace the Become CTA. Denied keeps apply so prospects can re-apply.
const CTA_REPLACING_STATUSES = new Set([
  "submitted",
  "under_review",
  "changes_requested",
  "approved",
])

export const shouldReplaceApplyCtaWithStatus = status => {
  if (!status) return false
  return CTA_REPLACING_STATUSES.has(String(status).toLowerCase())
}

export const isDeniedPtmApplication = status =>
  String(status || "").toLowerCase() === "denied"

export const mapPtmApplicationStatus = status => {
  if (!status) return null
  return STATUS_DISPLAY[String(status).toLowerCase()] || null
}

export const pickLatestApplicationForType = (applications, applicationType) => {
  if (!Array.isArray(applications) || !applicationType) return null

  const matches = applications.filter(
    app =>
      app?.applicationType &&
      String(app.applicationType).toLowerCase() ===
        String(applicationType).toLowerCase(),
  )

  if (matches.length === 0) return null

  return matches.reduce((latest, app) => {
    if (!latest) return app
    const latestUpdated = Date.parse(latest.updatedAt || 0) || 0
    const appUpdated = Date.parse(app.updatedAt || 0) || 0
    return appUpdated > latestUpdated ? app : latest
  }, null)
}
